
<template>
  <div>
    <div class="min-height page-not-found pt-1">
      <div class="main-div">
        <div class="text-center">
          <img src="/img/avatars/404_a.png" alt />
        </div>
        <div>
          <h4>we're Launching Soon !</h4>
          <h6>We can't find the page that you are looking for :(</h6>
        </div>
        <div class="text-center">
          <v-btn @click="goBack()" class="btn btn-grn-solid">Back</v-btn>
          <v-btn @click="goHome()" class="btn btn-grn-outline">Home</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getCurrentNav from "@/methods/utilities.vue";
export default {
  mixins: [getCurrentNav],
  data() {
    return { updated_nav: [] };
  },

  methods: {
    goBack() {
      this.$router.go(-2);
    },
    goHome() {
      this.updated_nav = JSON.parse(localStorage.getItem("updatedNav"));
      this.getCurrentNav(this.updated_nav);
    },
  },
};
</script>

